import React from "react";
import {
  Grid,
  Tooltip,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";

import { Paper, TextField, ComponentHeader } from "../../../components";

export default function RangeControl({ formikProps, editState }) {
  return (
    <Paper>
      <ComponentHeader title="Range Field Features" />

      <Grid size={12} sx={{ mb: "10px" }}>
        <Typography>NOTE: Range will be always in min and max. </Typography>
      </Grid>

      <Grid size={6}>
        <TextField
          required
          formikProps={formikProps}
          name="minDefaultValue"
          label="Min Default Value"
          disabled={!editState}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          required
          formikProps={formikProps}
          name="maxDefaultValue"
          label="Max Default Value"
          disabled={!editState}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          required
          formikProps={formikProps}
          name="rangelabel1"
          label="Min Range Label"
          disabled={!editState}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          required
          formikProps={formikProps}
          name="rangelabel2"
          label="Max Range Label"
          disabled={!editState}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          required
          formikProps={formikProps}
          name="errorMessage"
          label="Error Message"
          disabled={!editState}
        />
      </Grid>

      <Grid size={6}>
        <FormControlLabel
          control={
            <Tooltip title="Enable this to make the copy icon on text field so that you can copy the value by clicking on it.">
              <Switch
                checked={formikProps.values.copyable}
                name="copyable"
                onChange={formikProps.handleChange}
                disabled={!editState}
              />
            </Tooltip>
          }
          label="Copy Icon"
        />
      </Grid>

      <Grid size={2}>
        {Boolean(formikProps.values.multiline) && (
          <TextField
            type="number"
            formikProps={formikProps}
            name="rows"
            label="Rows in Text Field"
            disabled={!editState}
          />
        )}
      </Grid>
    </Paper>
  );
}
